import {Activity, ActivityType} from '../activity';
import {Definition} from '../definition';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class SendEmailNotificationActivity extends Activity {
  public Advanced: boolean;
  public QueryResources: boolean;
  public QueriesTable: Definition[];
  public ActivityExecutionCondition: string;
  public Iteration: string;
  public WorkflowDataVariablesTable: Definition[];
  public EmailTemplate: string;
  public To: string;
  public CC: string;
  public Bcc: string;
  public SuppressException: boolean;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.SendEmailNotification);
    this._properties['Advanced'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['QueryResources'] = ActivityPropertyDataType.BOOLEAN;
    this._properties['QueriesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['Iteration'] = ActivityPropertyDataType.STRING;
    this._properties['WorkflowDataVariablesTable'] = ActivityPropertyDataType.DEFINITION_TABLE;
    this._properties['EmailTemplate'] = ActivityPropertyDataType.STRING;
    this._properties['To'] = ActivityPropertyDataType.STRING;
    this._properties['CC'] = ActivityPropertyDataType.STRING;
    this._properties['Bcc'] = ActivityPropertyDataType.STRING;
    this._properties['SuppressException'] = ActivityPropertyDataType.BOOLEAN;
    this._advancedProperties = [
      'QueryResources',
      'QueriesTable',
      'ActivityExecutionCondition',
      'Iteration',
      'WorkflowDataVariablesTable',
      'CC',
      'Bcc',
      'SuppressException',
    ];
    this.parse(activityNode);
  }

  beforeSave(): void {
    super.beforeSave();
    if (this.QueryResources === false) {
      this.QueriesTable = null;
    }
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('send-email-notification', this.dialogConfig);
  }
}
